"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialState = void 0;

var getInitialState = function getInitialState() {
  return {
    x: 0,
    y: 0,
    start: 0,
    isSwiping: false
  };
};

exports.getInitialState = getInitialState;


//////////////////
// WEBPACK FOOTER
// ./~/vanilla-swipe/lib/utils/getInitialState.js
// module id = 94
// module chunks = 0